module.exports = __webpack_public_path__ + "static/small-business-integrations.b69787d5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/za/integrations/images/xero/small-business-integrations.jpg
// module id = 1608
// module chunks = 106061173438730